/**
 * Documentation DOCHAZKA API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateUserRequest { 
    /**
     * First name
     */
    firstname: string;
    /**
     * Last name
     */
    lastname: string;
    /**
     * Email
     */
    email: string;
    /**
     * Phone
     */
    phone?: string;
    /**
     * About me
     */
    aboutMe?: string;
    /**
     * password
     */
    password: string;
    /**
     * Center ID
     */
    centerId?: number;
    /**
     * User group ID
     */
    groupId?: number;
    /**
     * Role name
     */
    role?: string;
    /**
     * Confirmation password
     */
    passwordConfirmation: string;
}

